import React from 'react';
import { client } from '@api';
import {
    AddCoupomCallProps,
    AddItemDataProps,
    CartTypeCallProps,
    HandleCartInBoxProductProps,
    HandleItemProps,
    IsItemInCartProps,
} from '@interfaces/Services';
import { DEFAULTS } from './DEFAULTS';
import { servicesUtils } from '@utils';
import { useGlobal } from '@hooks/global';
import { StoreType } from '@types';

export const userCart = () => {
    const { services } = client();
    const global = useGlobal();
    const [listCart, setListCart] = React.useState(
        DEFAULTS.USER.CART.LIST,
    );

    // eslint-disable-next-line max-len
    const cartType = localStorage.getItem('storeType') as StoreType ?? global.app.view.application.type;

    const load = async ({ cartType }: CartTypeCallProps) => {
        const session = await global.app.cookies.get('session');
        if (session.error) {
            const response = await services.user.cart.load({
                cartType,
            });
            setListCart((prev) => prev = {
                ...prev,
                data: response?.response.payload ?
                    response?.response.payload : DEFAULTS.USER.CART.LIST.data,
                status: servicesUtils.noValidToken.response.status,
                message: servicesUtils.noValidToken.response.message,
                isLoaded: false,
            });
            return servicesUtils.noValidToken;
        }
        await services.purchase.shipping.calculateValue(cartType);
        const response = await services.user.cart.load({
            cartType,
        });
        setListCart((prev) => prev = {
            message: response?.response.message ?
                response?.response.message :
                '',
            isLoaded: true,
            status: response?.response.status,
            data: response?.response.payload ?
                response?.response.payload : DEFAULTS.USER.CART.LIST.data,
        });
        return response;
    };

    const clear = () => {
        return setListCart(DEFAULTS.USER.CART.LIST);
    };

    const addItem = async (data: AddItemDataProps) => {
        return await services.user.cart.addItem({
            cartType, data,
        });
    };

    const deleteItem = async (data: HandleItemProps) => {
        return await services.user.cart.deleteItem({ data, cartType });
    };

    const addCoupon = async (data: AddCoupomCallProps) => {
        return await services.user.cart.addCoupon({ ...data });
    };

    const removeCoupon = async () => {
        return await services.user.cart.removeCoupon({ cartType });
    };

    const addPoints = async () => {
        return await services.user.cart.addPoints();
    };

    const removePoints = async () => {
        return await services.user.cart.removePoints();
    };

    const addWallet = async () => {
        return await services.user.cart.addWallet({ cartType });
    };

    const removeWallet = async () => {
        return await services.user.cart.removeWallet({ cartType });
    };

    const boxProduct = async ({
        cart, product,
    }: HandleCartInBoxProductProps) => {
        const props = {
            idAd: product._id,
            idVariation: product.variations._id,
            variationItemId: product.variations.items[0]._id,
            quantity: 1,
        };

        const verify = isItemInCart({
            cart: cart.list.data,
            variationItemId: product.variations.items[0]._id,
        });

        if (!!verify) {
            const responseCartDeleteItem = await cart.handleItem.delete(props);
            await cart.load({ cartType });
            return responseCartDeleteItem;
        }

        const response = await cart.handleItem.add(props);

        // if (response?.error) {
        //     const responseCartDeleteItem = await cart.handleItem.delete(props);
        //     await cart.load({ cartType });
        //     return responseCartDeleteItem;
        // }

        await cart.load({ cartType });
        return response;
    };

    const isItemInCart = ({ cart, variationItemId }: IsItemInCartProps) => {
        let i = false;
        if (Object.keys(cart).length === 0) {
            return i;
        }
        cart.stores.map((store) => {
            store.items.map((item) => {
                if (item.variationItem._id === variationItemId) {
                    i = true;
                }
            });
            return;
        });

        return i;
    };

    return {
        cart: {
            load,
            clear,
            isItemInCart,
            handleItem: {
                boxProduct,
                add: addItem,
                delete: deleteItem,
            },
            list: listCart,
            coupon: {
                add: addCoupon,
                remove: removeCoupon,
            },
            points: {
                add: addPoints,
                remove: removePoints,
            },
            wallet: {
                add: addWallet,
                remove: removeWallet,
            },
        },
    };
};
